import { Currency } from "../../currency/objects/currency";
import { Bill } from "../objects/bill";
import { BillPayment } from "../objects/billPayment";
import { CategoryDetail } from "../objects/categoryDetail";
import { Column } from "../objects/column";
import { PurchasesReceipt } from "../objects/purchasesReceipt";
import { PurchasesReceiptErrors } from "../objects/purchasesReceiptErrors";
import { PurchasesReceiptListConfiguration } from "../objects/purchasesReceiptListConfiguration";
import { PurchasesReceiptListCriteria } from "../objects/purchasesReceiptListCriteria";
import { PurchasesReceiptListFiltersCriteria } from "../objects/purchasesReceiptListFiltersCriteria";
import { PurchasesReceiptPaidListCriteria } from "../objects/purchasesReceiptPaidListCriteria";
import { PurchasesReceiptPaidListFiltersCriteria } from "../objects/purchasesReceiptPaidListFiltersCriteria";
import { PurchasesReceiptProviderListCriteria } from "../objects/purchasesReceiptProviderListCriteria";
import { PurchasesReceiptProviderListFiltersCriteria } from "../objects/purchasesReceiptProviderListFiltersCriteria";
import { PurchasesReceiptThirdPartyListCriteria, ThirdPartyListFiltersCriteria } from "../objects/purchasesReceiptThirdPartyList";
import { PurchasesReceiptUnpaidListCriteria } from "../objects/purchasesReceiptUnpaidListCriteria";
import { PurchasesReceiptUnpaidListFiltersCriteria } from "../objects/purchasesReceiptUnpaidListFiltersCriteria";
import { PurchasesStats } from "../objects/purchasesStats";
import { ThirdParty } from "../objects/thirdParty";


export const EMPTY_CURRENCY: Currency = {
    id: 47,
    symbol: '€',
    iso_code: 'EUR',
    international_name: 'Euro',
    usd_factor: '0.9',
    custom_currency: [],
    name: 'Euro'
};

export const EMPTY_BILL_PAYMENT: BillPayment = {
    id: 0,
    bills: [],
    payment_type: 'RM RGT4',
    provider: null,
    paid: false,
    amount: "",
    balance: "",
    creator: null,
    last_author: null,
    description: "",
    done_date: new Date(),
    identifier: "",
    paid_amount: "",
    trip_reference: null,
    currency: null,
    accounting_client_payment: null,
    payment_grouping: [],
    target_client: undefined
};

export const EMPTY_PURCHASES_STATS: PurchasesStats = {
    not_invoiced_count: 0,
    not_invoiced_amount: 0,
    late_invoice_count: 0,
    late_invoice_amount: 0,
    waiting_pay_count: 0,
    waiting_pay_amount: 0,
    paid_invoice_count: 0,
    paid_invoice_amount: 0
};

export const EMPTY_CATEGORY_DETAIL: CategoryDetail = {
    category: "",
    description: "",
    amount: ""
};

export const EMPTY_BILL: Bill = {
    provider: null,
    category_details: [{ ...EMPTY_CATEGORY_DETAIL }, { ...EMPTY_CATEGORY_DETAIL }],
    files: [],
    attachments: [],
    accountingbooks: [],
    invoice_date: new Date(),
    invoice_number: '',
    due_date: null,
    payment_delay: null,
    currency: { ...EMPTY_CURRENCY },
    paid: false,
    amount: '',
    balance: '',
    export_date: null,
    is_automatic: false,
    creator: null,
    last_author: null,
    id: 0,
    note: '',
    paid_amount: null,
    product_start_date: null,
    invoice_type: 'PURCHASE',
    done_payments: null,
    trip: null,
    trip_reference: '',
    trip_version: '',
    insurance_contract: null,
    description: '',
    content_types: [],
    target_client: undefined,
    provider_invoice_number: null
};

export const EMPTY_PURCHASES_RECEIPT: PurchasesReceipt = {
    id: -1,
    is_automatic: false,
    provider: null,
    product_type: 0,
    product_booking_date: null,
    product_start_date: null,
    product_description: null,
    product_booking_ref: "",
    invoice_date: null,
    export_date: null,
    payment_limit_date: null,
    payment_delay: null,
    currency: EMPTY_CURRENCY,
    note: '',
    balance: "",
    category: "",
    amount: "",
    origin_amount: "",
    paid: "",
    factor_used: "",
    custom_rate: null,
    is_sent: false,
    trip: null,
    trip_version: null,
    origin_currency: EMPTY_CURRENCY,
    owner: {
        id: 0,
        name: "",
        type: 0,
        logo: null,
        logo_minimal: null,
        phone_number: null,
        street: null,
        zip_code: null,
        city: null
    },
    creator: null,
    last_author: null,
    category_details: [{ ...EMPTY_CATEGORY_DETAIL }, { ...EMPTY_CATEGORY_DETAIL }],
    files: [],
    attachments: [],
    invoice: null,
    name: "",
    trip_reference: null,
    document: null,
    paid_amount: null,
    accountingbooks: [],
    done_payments: null,
    insurance_contract: null,
    target_client: undefined
};

export const EMPTY_PURCHASES_RECEIPT_FILTERS: PurchasesReceiptListFiltersCriteria = {
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 12,
    provider: null,
    currency: null,
    period: "MODIFICATION",
    insurance_contract__contracts_type__name__unaccent__icontains: ""
};

export const EMPTY_PURCHASES_RECEIPT_LIST_CRITERIA: PurchasesReceiptListCriteria = {
    limit: 50,
    page: 0,
    order_by: '',
    order: 'asc',
    filters: EMPTY_PURCHASES_RECEIPT_FILTERS,
    search: ''
};

export const EMPTY_PURCHASES_RECEIPT_PROVIDER_FILTERS: PurchasesReceiptProviderListFiltersCriteria = {
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 0,
    period: "MODIFICATION",
    payment_type: 'undefined',
    provider: null
};


export const EMPTY_PURCHASES_RECEIPT_PROVIDER_LIST_CRITERIA: PurchasesReceiptProviderListCriteria = {
    limit: 50,
    page: 0,
    order_by: '',
    order: 'asc',
    filters: EMPTY_PURCHASES_RECEIPT_PROVIDER_FILTERS,
    search: ''
};

export const EMPTY_PURCHASES_RECEIPT_UNPAID_FILTERS: PurchasesReceiptUnpaidListFiltersCriteria = {
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 12,
    period: "MODIFICATION",
    provider: null,
    insurance_contract__contracts_type__name__unaccent__icontains: ""
};


export const EMPTY_PURCHASES_RECEIPT_UNPAID_LIST_CRITERIA: PurchasesReceiptUnpaidListCriteria = {
    limit: 50,
    page: 0,
    order_by: '',
    order: 'asc',
    filters: EMPTY_PURCHASES_RECEIPT_UNPAID_FILTERS,
    search: ''
};

export const EMPTY_PURCHASES_RECEIPT_PAID_FILTERS: PurchasesReceiptPaidListFiltersCriteria = {
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 12,
    period: "MODIFICATION",
    payment_type: 'undefined',
};


export const EMPTY_PURCHASES_RECEIPT_PAID_LIST_CRITERIA: PurchasesReceiptPaidListCriteria = {
    limit: 50,
    page: 0,
    order_by: '',
    order: 'asc',
    filters: EMPTY_PURCHASES_RECEIPT_PAID_FILTERS,
    search: ''
};

export const EMPTY_PURCHASES_RECEIPT_ERRORS: PurchasesReceiptErrors = {
    code_error: "",
    due_date_error: "",
    trip_error: "",
    invoice_error: ""
};

export const DEFAULT_COLUMN: Column[] = [
    {
        label: 'state-column',
        field_name: 'STATUS',
        checked: true,
        order_by: 'export_date',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'source',
        field_name: 'SOURCE',
        checked: true,
        order_by: 'is_automatic',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'folder',
        field_name: 'TRIP_NUMBER',
        checked: true,
        order_by: 'trip_reference',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'provider',
        field_name: 'PROVIDER',
        checked: true,
        order_by: 'provider',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'type',
        field_name: 'TYPE',
        checked: true,
        order_by: 'product_type',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'departure-date',
        field_name: 'DEPARTURE_DATE',
        checked: true,
        order_by: 'product_start_date',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'description',
        field_name: 'DESCRIPTION',
        checked: true,
        order_by: 'name',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'product-booking-ref',
        field_name: 'PRODUCT_BOOKING_REF',
        checked: true,
        order_by: 'product_booking_ref',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'product-booking-date',
        field_name: 'PRODUCT_BOOKING_DATE',
        checked: true,
        order_by: 'product_booking_date',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'status',
        field_name: 'COLLECTION',
        checked: true,
        order_by: 'is_paid',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'amount',
        field_name: 'AMOUNT',
        checked: true,
        order_by: 'amount',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'balance',
        field_name: 'BALANCE',
        checked: false,
        order_by: 'balance',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: false,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: false,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false
    }
];

const subDomain = window.location.host.split('.')[0];

export const CTI_COLUMN: Column[] = [
    {
        label: 'state-column',
        field_name: 'STATUS',
        checked: true,
        order_by: 'export_date',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'source',
        field_name: 'SOURCE',
        checked: true,
        order_by: 'is_automatic',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'folder',
        field_name: 'TRIP_NUMBER',
        checked: true,
        order_by: 'trip_reference',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'provider',
        field_name: 'PROVIDER',
        checked: true,
        order_by: 'provider',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'type',
        field_name: 'TYPE',
        checked: true,
        order_by: 'product_type',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'departure-date',
        field_name: 'DEPARTURE_DATE',
        checked: true,
        order_by: 'product_start_date',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'description',
        field_name: 'DESCRIPTION',
        checked: true,
        order_by: 'name',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'product-booking-ref',
        field_name: 'PRODUCT_BOOKING_REF',
        checked: true,
        order_by: 'product_booking_ref',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'product-booking-date',
        field_name: 'PRODUCT_BOOKING_DATE',
        checked: true,
        order_by: 'product_booking_date',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'status',
        field_name: 'COLLECTION',
        checked: true,
        order_by: 'is_paid',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'amount',
        field_name: 'AMOUNT',
        checked: true,
        order_by: 'amount',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'origin-amount',
        field_name: 'ORIGIN_AMOUNT',
        checked: true,
        order_by: 'origin_amount',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'balance',
        field_name: 'BALANCE',
        checked: false,
        order_by: 'balance',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: false,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: false,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false
    }
];


export const DEFAULT_VA_COLUMN: Column[] = [
    {
        label: 'state-column',
        field_name: 'STATUS',
        checked: true,
        order_by: 'export_date',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'source',
        field_name: 'SOURCE',
        checked: true,
        order_by: 'is_automatic',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'reference',
        field_name: 'REFERENCE',
        checked: true,
        order_by: 'insurance_contract__reference',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'subscription-method',
        field_name: 'SUBSCRIPTION_METHOD',
        checked: true,
        order_by: 'insurance_contract__contracts_type__name',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'provider',
        field_name: 'PROVIDER',
        checked: true,
        order_by: 'provider',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'type',
        field_name: 'TYPE',
        checked: true,
        order_by: 'product_type',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'departure-date',
        field_name: 'DEPARTURE_DATE',
        checked: true,
        order_by: 'product_start_date',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'description',
        field_name: 'DESCRIPTION',
        checked: true,
        order_by: 'name',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'product-booking-ref',
        field_name: 'PRODUCT_BOOKING_REF',
        checked: true,
        order_by: 'product_booking_ref',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'product-booking-date',
        field_name: 'PRODUCT_BOOKING_DATE',
        checked: true,
        order_by: 'product_booking_date',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'status',
        field_name: 'COLLECTION',
        checked: true,
        order_by: 'is_paid',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'amount',
        field_name: 'AMOUNT',
        checked: true,
        order_by: 'amount',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'balance',
        field_name: 'BALANCE',
        checked: false,
        order_by: 'balance',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: false,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: false,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false
    }
];

export const PROVIDER_COLUMN: Column[] = [
    {
        label: 'provider',
        field_name: 'PROVIDER_NAME',
        checked: true,
        order_by: 'provider__name',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'third-party',
        field_name: 'THIRD_PARTY',
        checked: true,
        order_by: 'accounting_reference',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'pending-invoices',
        field_name: 'PENDING_INVOICES',
        checked: true,
        order_by: 'pending_invoices',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'opening-balance',
        field_name: 'OPENING_BALANCE',
        checked: true,
        order_by: 'opening_balance',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: false,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: false,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false
    }
];


export const UNPAID_COLUMN: Column[] = [
    {
        label: 'state-column',
        field_name: 'STATUS',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'source',
        field_name: 'SOURCE',
        checked: true,
        order_by: 'is_automatic',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'folder',
        field_name: 'TRIP_NUMBER',
        checked: true,
        order_by: 'trip_reference',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'provider',
        field_name: 'PROVIDER',
        checked: true,
        order_by: 'provider',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'type',
        field_name: 'TYPE',
        checked: true,
        order_by: 'product_type',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'departure-date',
        field_name: 'DEPARTURE_DATE',
        checked: true,
        order_by: 'product_start_date',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'description',
        field_name: 'DESCRIPTION',
        checked: true,
        order_by: 'name',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'invoice-date',
        field_name: 'INVOICE_DATE',
        checked: true,
        order_by: 'invoice_date',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'invoice-number',
        field_name: 'INVOICE_NUMBER',
        checked: true,
        order_by: 'invoice_number',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'status',
        field_name: 'COLLECTION',
        checked: true,
        order_by: 'is_paid',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'amount',
        field_name: 'AMOUNT',
        checked: true,
        order_by: 'amount',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'balance',
        field_name: 'BALANCE',
        checked: false,
        order_by: 'balance',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: false,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: false,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false
    }
];


export const UNPAID_COLUMN_CTI: Column[] = [
    {
        label: 'state-column',
        field_name: 'STATUS',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'source',
        field_name: 'SOURCE',
        checked: true,
        order_by: 'is_automatic',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'folder',
        field_name: 'TRIP_NUMBER',
        checked: true,
        order_by: 'trip_reference',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'provider',
        field_name: 'PROVIDER',
        checked: true,
        order_by: 'provider',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'supplier-invoice-number',
        field_name: 'PROVIDER_INVOICE_NUMBER',
        checked: true,
        order_by: 'provider_invoice_number',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'type',
        field_name: 'TYPE',
        checked: true,
        order_by: 'product_type',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'departure-date',
        field_name: 'DEPARTURE_DATE',
        checked: true,
        order_by: 'product_start_date',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'description',
        field_name: 'DESCRIPTION',
        checked: true,
        order_by: 'name',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'invoice-date',
        field_name: 'INVOICE_DATE',
        checked: true,
        order_by: 'invoice_date',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'invoice-number',
        field_name: 'INVOICE_NUMBER',
        checked: true,
        order_by: 'invoice_number',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'status',
        field_name: 'COLLECTION',
        checked: true,
        order_by: 'is_paid',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'amount',
        field_name: 'AMOUNT',
        checked: true,
        order_by: 'amount',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'balance',
        field_name: 'BALANCE',
        checked: false,
        order_by: 'balance',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: false,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: false,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false
    }
];


export const UNPAID_VA_COLUMN: Column[] = [
    {
        label: 'state-column',
        field_name: 'STATUS',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'source',
        field_name: 'SOURCE',
        checked: true,
        order_by: 'is_automatic',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'reference',
        field_name: 'REFERENCE',
        checked: true,
        order_by: 'insurance_contract__reference',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'subscription-method',
        field_name: 'SUBSCRIPTION_METHOD',
        checked: true,
        order_by: 'insurance_contract__contracts_type__name',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'provider',
        field_name: 'PROVIDER',
        checked: true,
        order_by: 'provider',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'type',
        field_name: 'TYPE',
        checked: true,
        order_by: 'product_type',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'departure-date',
        field_name: 'DEPARTURE_DATE',
        checked: true,
        order_by: 'product_start_date',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'description',
        field_name: 'DESCRIPTION',
        checked: true,
        order_by: 'name',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'invoice-date',
        field_name: 'INVOICE_DATE',
        checked: true,
        order_by: 'invoice_date',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'invoice-number',
        field_name: 'INVOICE_NUMBER',
        checked: true,
        order_by: 'invoice_number',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'status',
        field_name: 'COLLECTION',
        checked: true,
        order_by: 'is_paid',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'amount',
        field_name: 'AMOUNT',
        checked: true,
        order_by: 'amount',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'balance',
        field_name: 'BALANCE',
        checked: false,
        order_by: 'balance',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: false,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: false,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false
    }
];


export const PAID_COLUMN: Column[] = [
    {
        label: 'payment-date',
        field_name: 'DONE_DATE',
        checked: true,
        order_by: 'done_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'number-payment',
        field_name: 'COLLECTION_NUMBER',
        checked: true,
        order_by: 'identifier',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'provider',
        field_name: 'PROVIDER',
        checked: true,
        order_by: 'provider',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'payment-type',
        field_name: 'PAYMENT_TYPE',
        checked: true,
        order_by: 'payment_type',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'amount',
        field_name: 'AMOUNT',
        checked: true,
        order_by: 'amount',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: false,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: false,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false
    }
];

export const TOURIST_PAID_COLUMN: Column[] = [
    {
        label: 'payment-date',
        field_name: 'DONE_DATE',
        checked: true,
        order_by: 'done_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'number-payment',
        field_name: 'COLLECTION_NUMBER',
        checked: true,
        order_by: 'identifier',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'provider',
        field_name: 'PROVIDER',
        checked: true,
        order_by: 'provider',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'payment-type',
        field_name: 'PAYMENT_TYPE',
        checked: true,
        order_by: 'payment_type',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'amount',
        field_name: 'AMOUNT',
        checked: true,
        order_by: 'amount',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'origin-amount',
        field_name: 'ORIGIN_AMOUNT',
        checked: true,
        order_by: 'amount',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: false,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: false,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false
    }
];

export const EMPTY_THIRD_PARTY: ThirdParty = {
    id: 0,
    accounting_reference: "",
    provider: null
};

export const EMPTY_THIRD_PARTY_FILTERS: ThirdPartyListFiltersCriteria = {
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 0,
    period: "MODIFICATION",
};


export const EMPTY_THIRD_PARTY_LIST_CRITERIA: PurchasesReceiptThirdPartyListCriteria = {
    limit: 50,
    page: 0,
    order_by: 'modified_date',
    order: 'desc',
    filters: EMPTY_THIRD_PARTY_FILTERS,
    search: '',
    client_branch: null
};

export const THIRD_PARTY_COLUMN: Column[] = [
    {
        label: 'code',
        field_name: 'CODE',
        checked: true,
        order_by: 'accounting_reference',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'name',
        field_name: 'NAME',
        checked: true,
        order_by: 'provider',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'export-date',
        field_name: 'EXPORT_DATE',
        checked: true,
        order_by: 'export_date',
        fixed_width: true,
        last_updated: false
    },
    {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: true,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: false,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: false,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false
    }
];

export const EMPTY_THIRD_PARTY_LIST_CONFIGURATION: PurchasesReceiptListConfiguration = {
    columns: THIRD_PARTY_COLUMN,
    preferences: []
};

export const EMPTY_PURCHASES_RECEIPT_LIST_CONFIGURATION: PurchasesReceiptListConfiguration = {
    columns: subDomain === "valeurs-assurances" ? DEFAULT_VA_COLUMN : (subDomain === 'continents-insolites' || subDomain === 'tourist-forum') ? CTI_COLUMN : DEFAULT_COLUMN,
    preferences: []
};


export const EMPTY_PURCHASES_RECEIPT_PROVIDER_LIST_CONFIGURATION: PurchasesReceiptListConfiguration = {
    columns: PROVIDER_COLUMN,
    preferences: []
};

export const EMPTY_PURCHASES_RECEIPT_UNPAID_LIST_CONFIGURATION: PurchasesReceiptListConfiguration = {
    columns: (subDomain === 'continents-insolites' || subDomain === 'tourist-forum') ? UNPAID_COLUMN_CTI : UNPAID_COLUMN,
    preferences: []
};

export const EMPTY_PURCHASES_RECEIPT_PAID_LIST_CONFIGURATION: PurchasesReceiptListConfiguration = {
    columns: subDomain === 'tourist-forum' ? TOURIST_PAID_COLUMN : PAID_COLUMN,
    preferences: []
};

export const PURCHASES_RECEIPT_MODULE = 'PURCHASES_RECEIPT_MODULE';
export const PURCHASES_FORECAST_MODULE = 'PURCHASES_FORECAST_MODULE';
export const PURCHASES_PROVIDER_MODULE = 'PURCHASES_PROVIDER_MODULE';
export const PURCHASES_UNPAID_MODULE = 'PURCHASES_UNPAID_MODULE';
export const PURCHASES_PAID_MODULE = 'PURCHASES_PAID_MODULE';
export const PURCHASES_THIRD_PARTY_MODULE = 'PURCHASES_THIRD_PARTY_MODULE';

